import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-payment-method',
  templateUrl: './create-payment-method.component.html',
  styleUrls: ['./create-payment-method.component.scss']
})
export class CreatePaymentMethodComponent implements OnInit {
    org: any;

    constructor(@Inject(MAT_DIALOG_DATA)private data: any,
        private dialog: MatDialogRef<CreatePaymentMethodComponent>) { }

    ngOnInit(): void {
        this.org = this.data.organisation;
    }

    completeAction(){
        this.dialog.close();
    }

    methodCreated(method: any){
        if(method){
            this.dialog.close(method);
        }
    }

}
